import { useState } from "react";
import { Link } from "react-router-dom";
import { PRIVACY_POLICY_PATH } from "@/lib/constants";

const STORAGE_KEY = "buzas-lgpd-consent";

function readConsent() {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function saveConsent(value) {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // armazenamento bloqueado pelo navegador: a escolha vale só para esta visita
  }
}

export default function CookieConsent() {
  const [consent, setConsent] = useState(readConsent);

  if (consent) return null;

  const choose = (value) => {
    saveConsent(value);
    setConsent(value);
  };

  return (
    <div
      role="region"
      aria-label="Aviso de privacidade"
      data-testid="cookie-consent"
      className="fixed bottom-0 inset-x-0 z-[70] text-white shadow-[0_-8px_24px_-12px_rgba(0,0,0,0.45)]"
      style={{
        background: "var(--buzas-navy-dark)",
        borderTop: "1px solid rgba(255,255,255,0.12)",
      }}
    >
      <div className="container-buzas py-4 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
        <p
          className="text-[13px] leading-relaxed flex-1"
          style={{ color: "#CBD5E1" }}
        >
          Utilizamos cookies e tecnologias semelhantes para o funcionamento do
          site e, com o seu consentimento, para análise de navegação, conforme
          a Lei Geral de Proteção de Dados (LGPD). Saiba mais na nossa{" "}
          <Link
            to={PRIVACY_POLICY_PATH}
            data-testid="cookie-consent-policy-link"
            className="underline text-white hover:text-white/80"
          >
            Política de Privacidade
          </Link>
          .
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            type="button"
            onClick={() => choose("rejected")}
            data-testid="cookie-consent-reject"
            className="text-[14px] font-bold text-white rounded-md border border-white/40 hover:border-white transition-colors duration-200"
            style={{ padding: "8px 20px" }}
          >
            Recusar
          </button>
          <button
            type="button"
            onClick={() => choose("accepted")}
            data-testid="cookie-consent-accept"
            className="bg-[var(--buzas-red)] hover:bg-[var(--buzas-red-dark)] text-white text-[14px] font-bold rounded-md border border-transparent transition-colors duration-200"
            style={{ padding: "8px 20px" }}
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  );
}
